import { IArtist } from "../hooks/artists";
import { IUserProfile } from "../hooks/userProfiles";
import { IUserNotification } from "../hooks/userNotifications";
import { ITag } from "../hooks/tags";
import { IStore } from "../hooks/stores";
import { IShelving } from "../hooks/shelvings";
import { ISellValue } from "../hooks/sellValues";
import { ILabel } from "../hooks/labels";
import { IExchangeRate } from "../hooks/exchangeRates";
import { ICollection, IPublicCollection } from "../hooks/collections";
import { IAlbumType } from "../hooks/albumTypes";
import { IAlbumFormat } from "../hooks/albumFormats";
import { IImpact } from "../hooks/impacts";
import { ISleeveGrade } from "../hooks/sleeveGrades";
import { IMediaGrade } from "../hooks/mediaGrades";
import { IPublicAlbum } from "../hooks/albums";
import { DateHelper } from "./DateHelper";
import { IOriginCountry } from "../hooks/originCountries";
import { ICountry } from "../hooks/countries";
import { IGearItem } from "../hooks/gearItems";
import { IEquipment } from "../hooks/equipments";
import { IListeningSession } from "../hooks/listeningSessions";

export class DataStorage<T> {
  static expirationTimeInSeconds = 1800; // 30 minutes
  static artistStorage = new DataStorage<IArtist>(true);
  static labelStorage = new DataStorage<ILabel>(true);
  static storeStorage = new DataStorage<IStore>(true);
  static albumTypeStorage = new DataStorage<IAlbumType>(true);
  static albumFormatStorage = new DataStorage<IAlbumFormat>(true);
  static sellValueStorage = new DataStorage<ISellValue>(true);
  static exchangeRateStorage = new DataStorage<IExchangeRate>(true);
  static tagStorage = new DataStorage<ITag>(true);
  static originCountryStorage = new DataStorage<IOriginCountry>(true);
  static gearItemStorage = new DataStorage<IGearItem>(true);
  static equipmentsStorage = new DataStorage<IEquipment>(true);
  static listeningSessionsStorage = new DataStorage<IListeningSession>(true);
  static shelvingStorage = new DataStorage<IShelving>(true);
  static collectionStorage = new DataStorage<ICollection>(true);
  static userProfileStorage = new DataStorage<IUserProfile>(false);
  static userNotificationStorage = new DataStorage<IUserNotification>(true);
  static publicCollectionStorage = new DataStorage<IPublicCollection>(true);
  static impactsStorage = new DataStorage<IImpact>(true);
  static countriesStorage = new DataStorage<ICountry>(true);
  static sleeveGradeStorage = new DataStorage<ISleeveGrade>(true);
  static mediaGradeStorage = new DataStorage<IMediaGrade>(true);
  static highlightedCollectionStorage = new DataStorage<IPublicCollection>(true);
  static highlightedAlbumStorage = new DataStorage<IPublicAlbum>(true);
  constructor(isEnabled: boolean) {
    this.isEnabled = isEnabled;
  }
  static reset() {
    DataStorage.resetAttributeData();
    DataStorage.shelvingStorage.data = undefined;
    DataStorage.collectionStorage.data = undefined;
    DataStorage.userProfileStorage.data = undefined;
    DataStorage.userNotificationStorage.data = undefined;
    DataStorage.publicCollectionStorage.data = undefined;
  }
  static resetAttributeData() {
    DataStorage.artistStorage.data = undefined;
    DataStorage.labelStorage.data = undefined;
    DataStorage.storeStorage.data = undefined;
    DataStorage.albumTypeStorage.data = undefined;
    DataStorage.albumFormatStorage.data = undefined;
    DataStorage.sellValueStorage.data = undefined;
    DataStorage.exchangeRateStorage.data = undefined;
    DataStorage.tagStorage.data = undefined;
    DataStorage.originCountryStorage.data = undefined;
    DataStorage.gearItemStorage.data = undefined;
    DataStorage.equipmentsStorage.data = undefined;
    DataStorage.listeningSessionsStorage.data = undefined;
  }
  isEnabled: boolean;
  isPublic: boolean;
  collectionId: string;
  data: T[];
  lastSetted: number;
  setData(data: T[], isPublic: boolean, collectionId: string) {
    this.isPublic = isPublic;
    this.collectionId = collectionId;
    this.data = data;
  }
  getData(isPublic: boolean, collectionId: string) {
    if (!this.isEnabled) return undefined;
    if (DateHelper.dateNowInSeconds() - this.lastSetted > DataStorage.expirationTimeInSeconds) {
      return undefined;
    }
    if (this.isPublic == isPublic) {
      if (isPublic && this.collectionId == collectionId) {
        return this.data;
      } else if (!isPublic) {
        return this.data;
      }
    }
    return undefined;
  }
}
